import { useReducer } from 'react';

const toggler = (state: boolean) => !state;
export function useToggle(defaultValue = false) {
    const [state, toggle] = useReducer(toggler, defaultValue);

    return [state, toggle] as const;
}
